function loadScriptAsync(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    script.onload = () => {
      resolve();
    };

    script.onerror = () => {
      reject(new Error(`Não foi possível carregar o script: ${url}`));
    };

    document.head.appendChild(script);
  });
}
export default loadScriptAsync;
